import React, { useEffect, useRef } from 'react'
import { Col, Card } from "react-bootstrap";
import ChartPieAge from "./DonorsAgePieChart"
import { useDonor } from '../../../../../context/donor/donor.context';
import { useTranslation } from "react-i18next";
const DonorsAgePieChart = () => {
    const { 
        ageStatistics, 
        fetchDonorsAgeStatistics, 
        loading 
    } = useDonor();
    const { t } = useTranslation();
    const hasFetchedRef = useRef(false);
    
    useEffect(() => {
        if (!hasFetchedRef.current) {
            fetchDonorsAgeStatistics();
            hasFetchedRef.current = true;
        }
    }, []);

    const handleRefresh = () => {
        fetchDonorsAgeStatistics();
    };

    return (
        <Col xl={6} lg={6}>
            <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <Card.Title>{t("Age Distribution")}</Card.Title>
                    <button 
                        className="btn btn-sm btn-primary" 
                        onClick={handleRefresh}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                {t("Loading")}...
                            </>
                        ) : (
                            <>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    width="16" 
                                    height="16" 
                                    fill="currentColor" 
                                    className="me-1" 
                                    viewBox="0 0 16 16"
                                >
                                    <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                </svg>
                            </>
                        )}
                    </button>
                </Card.Header>
                <Card.Body style={{ minHeight: '500px' }}>
                    {loading ? (
                        <div className="text-center">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">{t("Loading")}...</span>
                            </div>
                        </div>
                    ) : ageStatistics ? (
                        <>
                            <div style={{ height: '400px', width: '100%' }}>
                                <ChartPieAge ageStatistics={ageStatistics} />
                            </div>
                            <div className="mt-3 text-center">
                                <p><strong>{t("donors.totalDonors")}:</strong> {ageStatistics.total}</p>
                                <div className="row">
                                    {ageStatistics.chartData.map((item, index) => (
                                        <div key={index} className="col-6 col-md-4 mb-2">
                                            <strong>{item.category}:</strong> {item.count} ({item.percentage}%)
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="text-center">{t("No data available")}</div>
                    )}
                </Card.Body>
            </Card>
        </Col>
    )
}

export default DonorsAgePieChart